import NamesControl from "./NamesControl";
import PathShownControl from "./PathShownControl";
import SelectedControl from "./SelectedControl";

export default class MapControls {
  static Names = NamesControl;
  static Paths = PathShownControl;
  static Selected = SelectedControl;
}
